module.exports = __webpack_public_path__ + "static/memoq-server-address-17f932e7e5bfe7beebe29aa08474e932.png";